import styled from 'styled-components'

const Wrapper = styled.div`
  min-height: 200vh;
  display: flex;
  border-top: 1px solid #e5e7eb;
  /* overflow: hidden; */
  .slide-wrap {
    width: 100%;
    position: relative;
    min-height: 100%;
    .panel {
      position: relative;
      z-index: 1;
    }
    .detail {
      opacity: 0;
      transform: translateY(-300px);
    }
    .panel,
    .detail {
      transition: opacity 300ms 500ms, transform 300ms 300ms;
      background-color: white;
    }
    &.wrap-enter {
      .panel {
        opacity: 0;
        z-index: 0;
      }
      .detail {
        transform: translateY(0);
        @media (orientation: portrait) {
          transform: translateY(30vh);
        }
      }
    }
    &.wrap-enter-done {
      .panel {
        opacity: 0;
        z-index: 0;
      }
      .detail {
        opacity: 1;
        z-index: 1;
        transform: translateY(0);
        @media (orientation: portrait) {
          transform: translateY(30vh);
        }
      }
    }
    &.wrap-enter-active {
      .panel {
        opacity: 0;
        z-index: 0;
      }
      .detail {
        opacity: 1;
        z-index: 1;
      }
    }

    &.wrap-exit-active {
      .panel {
        opacity: 1;
        z-index: 1;
      }
      .detail {
        transition: translateY(-200px);
        opacity: 0;
        z-index: 0;
      }
    }
  }
`

const ColDetail = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`

export { Wrapper, ColDetail }
